import React from 'react';
import { Card } from 'ui-toolkit';
import { IFetchStatus } from 'types/rest/IFetchStatus';
import { IStandardDocumentsTableProps } from 'components/order/documentsPortal/standardDocuments/StandardDocumentsTable';
import { IStandardDocumentVersionData } from 'types/order/documents/shared/interfaces';
import { IUploadDocument } from 'types/order/documents/upload/interfaces';
import { IFetchDataState } from 'store/IFetchDataState';
import { ICreateDocumentAccess } from 'types/documents/ICreateDocumentAccess';
import { IDocumentAccessData } from 'types/documents/IDocumentAccess';
import { StandardDocumentsTableAndMerge } from 'components/order/documentsPortal/standardDocuments/StandardDocumentsTableAndMerge';
import { IDocumentCategory } from 'types/order/documents/IDocumentCategoryType';

export interface IStandardDocumentsPageProps extends IStandardDocumentsTableProps {
  uploadDocumentFetch: IFetchStatus;
  onUploadDocuments: (documents: IUploadDocument[]) => Promise<any>;
  onUploadDocumentReset: () => void;
  onMergeDocuments: (docIds: string[], fileName: string | undefined, category: IDocumentCategory) => void;
  onCloseMerge: () => void;
  onGenerateLink: (createDocumentAccess: ICreateDocumentAccess) => void;
  postGenerateLink: IFetchDataState<ICreateDocumentAccess, IDocumentAccessData>;
  onResetGenerateLink: () => void;
  onFinalizeDocument: (docId: string, versionId: string) => void;
  resetFinalDocumentForm: () => void;
  onCloseFinalizeModal: () => void;
  onDetailsClick: (document: IStandardDocumentVersionData) => void;
  onCloseDetailsSideSheet: () => void;
}

export const StandardDocumentsPage: React.FC<IStandardDocumentsPageProps> = ({
  isAmericanDigital,
  documents,
  users,
  parties,
  onPublish,
  onUnpublish,
  onSigningClick,
  onFundingClick,
  onUploadDocuments,
  onUploadDocumentReset,
  uploadDocumentFetch,
  onEditDocument,
  onEditDocumentReset,
  onDeleteDocumentReset,
  editDocumentFetch,
  onMergeDocuments,
  onCloseMerge,
  documentsActionError,
  documentsActionFetchStatus,
  onGenerateLink,
  postGenerateLink,
  onResetGenerateLink,
  onFinalizeDocument,
  resetFinalDocumentForm,
  onCloseFinalizeModal,
  onDetailsClick,
  onCloseDetailsSideSheet,
  categories,
  isZDocLoading,
}) => {
  return (
    <Card title={'Standard Documents'}>
      <StandardDocumentsTableAndMerge
        isZDocLoading={isZDocLoading}
        categories={categories}
        isAmericanDigital={isAmericanDigital}
        documents={documents}
        users={users}
        parties={parties}
        onPublish={onPublish}
        onUnpublish={onUnpublish}
        onSigningClick={onSigningClick}
        onFundingClick={onFundingClick}
        onEditDocument={onEditDocument}
        onEditDocumentReset={onEditDocumentReset}
        onDeleteDocumentReset={onDeleteDocumentReset}
        editDocumentFetch={editDocumentFetch}
        documentsActionError={documentsActionError}
        documentsActionFetchStatus={documentsActionFetchStatus}
        onGenerateLink={onGenerateLink}
        postGenerateLink={postGenerateLink}
        onResetGenerateLink={onResetGenerateLink}
        onCloseMerge={onCloseMerge}
        onMergeDocuments={onMergeDocuments}
        onUploadDocuments={onUploadDocuments}
        onUploadDocumentReset={onUploadDocumentReset}
        uploadDocumentFetch={uploadDocumentFetch}
        onFinalizeDocument={onFinalizeDocument}
        resetFinalDocumentForm={resetFinalDocumentForm}
        onCloseFinalizeModal={onCloseFinalizeModal}
        onDetailsClick={onDetailsClick}
        onCloseDetailsSideSheet={onCloseDetailsSideSheet}
      />
    </Card>
  );
};
